/**
 * Taslak ekranlarının "Word'e Aktar" çıktısı için belge iskeleti.
 *
 * Word'ün HTML içe aktarıcısı tarayıcı gibi davranmaz: içeriği sayfa metin genişliğine
 * göre OTOMATİK ÖLÇEKLEMEZ. Kağıt boyutu ve kenar boşlukları `@page` ile bildirilmezse
 * dar bir varsayılan metin alanına düşer; genişliği aşan tablolar küçültülmek yerine
 * sağ marjinden taşar ve son sütunlar sayfa dışında kalır.
 *
 * Bu yüzden çıktı; adlandırılmış bir `@page` bölümü (Word'ün beklediği "Section1"
 * kalıbı), gövdeyi saran `div.Section1` ve tabloları sayfa genişliğiyle sınırlayan
 * temel kurallarla üretilir.
 */

/** A4 kısa kenar (cm). */
const SAYFA_GENISLIGI_CM = 21.0;
/** A4 uzun kenar (cm). */
const SAYFA_YUKSEKLIGI_CM = 29.7;
/** Her kenardan boşluk (cm). 1,5 cm => 18 cm metin genişliği. */
const KENAR_BOSLUGU_CM = 1.5;

/** Word'ün `@page` desteği için kullanılan bölüm adı. */
export const WORD_BOLUM_ADI = "Section1";

/** Dışa aktarılan belgenin sayfa geometrisi ve tablo sınırlama kuralları. */
export const WORD_SAYFA_STILI =
  `@page ${WORD_BOLUM_ADI} { ` +
  `size: ${SAYFA_GENISLIGI_CM}cm ${SAYFA_YUKSEKLIGI_CM}cm; ` +
  `margin: ${KENAR_BOSLUGU_CM}cm ${KENAR_BOSLUGU_CM}cm ${KENAR_BOSLUGU_CM}cm ${KENAR_BOSLUGU_CM}cm; ` +
  `mso-page-orientation: portrait; }` +
  `div.${WORD_BOLUM_ADI} { page: ${WORD_BOLUM_ADI}; }` +
  `table { max-width: 100%; table-layout: fixed; }` +
  `td, th { word-wrap: break-word; overflow-wrap: break-word; }`;

/**
 * Verilen taslak HTML'ini Word'ün açabileceği tam bir belgeye sarar.
 * @param icerikHtml Taslak bileşeninin innerHTML'i (stil bilgisi satır içi olmalıdır;
 *                   `scoped` CSS bu kopyaya dahil olmaz).
 */
export function buildWordDocumentHtml(icerikHtml: string): string {
  return (
    "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
    "xmlns:w='urn:schemas-microsoft-com:office:word' " +
    "xmlns='http://www.w3.org/TR/REC-html40'>" +
    "<head><meta charset='utf-8'>" +
    "<style>" + WORD_SAYFA_STILI + "</style>" +
    "</head><body>" +
    `<div class='${WORD_BOLUM_ADI}'>` + (icerikHtml || "") + "</div>" +
    "</body></html>"
  );
}

/** `buildWordDocumentHtml` çıktısını `<a download>` için data URI'ye çevirir. */
export function buildWordDataUri(icerikHtml: string): string {
  return (
    "data:application/vnd.ms-word;charset=utf-8," +
    encodeURIComponent(buildWordDocumentHtml(icerikHtml))
  );
}
